import config from '@/config';
import request from '@/request/request.gateway.js';
import qs from 'qs';

export default {
	// 获取代理商账户资金
	getAgentCapital(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/agent/get_mercantile_agent_commission`,
			params
		});
	},
	// 获取代理商收益统计信息
	getRevenueStatistics(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/agent/get_agent_statistic`,
			params
		});
	},
	// 获取佣金明细
	getCapitalDetail(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/agent/get_agent_profit_detail_list`,
			params
		});
	},
	// 获取代理商账号信息
	getAgentAccount(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/agent/get_mercantile_agent_account`,
			params
		});
	},
	// 提现代理商分销佣金
	getAngentCommission(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/agent/withdraw_agent_distribution_commission`,
			data: qs.stringify(data)
		});
	},
	// 获取提现记录
	getWithdrawDetail(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/agent/get_agent_withdrawal_list`,
			params
		});
	},
	// 录入发票信息
	saveWithdrawInfo(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/agent/save_withdraw_invoice`,
			data: qs.stringify(data)
		});
	},
	// 代理商提现账号设置
	setAgentAccount(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/agent/set_mercantile_agent_account`,
			data: qs.stringify(data)
		});
	},
	// 获取登录角色
	getLoginRole(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/agent/check_role_identity`,
			params
		});
	},
	// 客户经理模糊搜索
	getAccountManageList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/agent/get_operator_list`,
			params
		});
	},
	// 代理商模糊搜索
	getAgentList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/agent/get_agent_list`,
			params
		});
	},
	// 代理商收益列表
	getAgentProfitList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/agent/get_agent_profit_list`,
			params
		});
	},
	// 代理商提现记录列表
	getAgentWithdrawaList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/agent/get_agent_withdrawal_list_by_operator`,
			params
		});
	},
	// 代理商收益明细列表
	getAgentProfitDetailList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/agent/get_agent_profit_list_by_operator`,
			params
		});
	}
};
